export default __webpack_public_path__ + "static/media/FKGroteskNeue-Medium.ae9ae08a.otf";